"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var immer_1 = __importDefault(require("immer"));
var react_redux_1 = require("react-redux");
var TimeUtil_1 = require("../util/TimeUtil");
var useNow_1 = __importDefault(require("./useNow"));
function usePlayer(playerId, _a) {
    var _b = _a === void 0 ? { withTimeUpdate: false } : _a, withTimeUpdate = _b.withTimeUpdate;
    var state = (0, react_redux_1.useSelector)(function (state) { return state; });
    var players = state.players;
    var standby = !withTimeUpdate || players.every(function (player) { var _a; return !((_a = player.time) === null || _a === void 0 ? void 0 : _a.playing); });
    var now = (0, useNow_1.default)({ standby: standby });
    if (!standby && state.players.every(function (player) { return player.time; })) {
        players = (0, immer_1.default)(players, function (draft) { return (0, TimeUtil_1.updatePlayersTime)(draft, now); });
    }
    var id = playerId !== undefined ? playerId : state.playerId;
    return players.find(function (player) { return player.id === id; });
}
exports.default = usePlayer;
